<template>
  <div>
    <v-text-field v-model="search" :full-width="true" append-icon="mdi-magnify" label="Search NPI, First Name, Last Name, Specialty" hide-details />
    <v-data-table :headers="headers" :items="sortedItems" :pagination.sync="pagination" :rowsPerPageItems="[5, 10, 25, 50]" :mustSort="false" :search="search">
      <template v-slot:items="{ item }">
        <td>
          <router-link :to="{ name: 'hcpProfile', params: { runId: $route.params.runId, cohortId: 1, npi: item.npi } }">Profile Link</router-link>
        </td>
        <td v-for="header in headers.tail()" :key="header.text">
          {{ item[header.value] }}
        </td>
      </template>
    </v-data-table>
  </div>
</template>


<script>

export default {
  props: ['modelData'],
  data() {
    return {
      headers: [
        { text: 'Profile Link', sortable: false, filterable: false, },
        { text: 'NPI', value: 'npi', },
        { text: 'First Name', value: 'firstName', },
        { text: 'Last Name', value: 'lastName', },
        { text: 'Specialty', value: 'specialty', },
        { text: 'National Importance %ile', value: 'globalPageRankPercentile', filterable: false, },
        { text: 'Specialty Importance %ile', value: 'specialtyPageRankPercentile', filterable: false, },
      ],
      pagination: {
        sortBy: null,
        page: 1,
        rowsPerPage: 50,
      },
      search: null,
    };
  },
  computed: {
    sortedItems() {
      return (this.modelData || [])
        .sortBy(f => f.specialtyPageRankPercentile)
        .reverse()
        .unique(f => f.npi);
    },
  },
}
</script>